import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../../../config/environment';
import Menu from '../../elements/Menu/menu';
import CheckAuth from '../../elements/checkAuth';
import './errorOrders.css';
import '../../../../styles/table.admin.css';
import PageMode from '../../elements/PageMode/pageMode';

const MODES = [ 'BUY', 'SELL', 'EXCHANGE', 'ALL' ];

export default function ErrorOrders() {
    const [state, setState] = useState({
        mode: 'BUY',
        ordersArray: [],
        changes: {}
    });

    useEffect(() => {
        const main = async () => {
            await axios.get(config.backendUrl + '/order/error-orders', { headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
            } })
            .then(response => setState(state => { return({ ...state, ordersArray: response.data }); }))
            .catch(error => {
                console.log(error.message);
                console.log(error.response.data.message);
                console.log(error);
                alert(error.response.data.message);
            });
        };
        main();
    }, []);

    const modeOnChangeHandler = async (event) => setState({ ...state, mode: event.target.value });

    const renderTable = () => {
        if (state.ordersArray.length === 0) { return; }
        
        let ordersArray = state.ordersArray;

        if (state.mode !== 'ALL') {
            ordersArray = ordersArray.filter(orderInfo => orderInfo.exchangeWayType === state.mode);
        }

        return(
            <>
            <div className="errorOrders__table_wrapper">
                <PageMode modesArray={ MODES } checkedMode={ state.mode } onChangeHandler={ modeOnChangeHandler } />
                <table className="table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Order hash</th>
                            <th>Exchange way</th>
                            <th>In amount</th>
                            <th>Amount after trade</th>
                            <th>Cashback token</th>
                            <th>Is withdrawn</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            ordersArray.map((orderInfo, index) => {
                                return(
                                    <tr>
                                        <td>{ orderInfo.date }</td>
                                        <td>{ orderInfo.orderHash }</td>
                                        <td>{ orderInfo.inCurrencyCode + ' >> ' + orderInfo.outCurrencyCode }</td>
                                        <td>{ orderInfo.inAmount + ' ' + orderInfo.inCurrencyCode }</td>
                                        <td>{ orderInfo.amountAfterTrade + ' ' + orderInfo.outCurrencyCode }</td>
                                        <td>{ orderInfo.cashbackToken || '–' }</td>
                                        <td><input type="checkbox" checked={ orderInfo.isWithdrawn } onChange={ checkboxChangeHandler(orderInfo.orderHash) }/></td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
            <div className="errorOrders__saveButton_wrapper"><button onClick={ saveButtonHandler }>Save</button></div>
            </>
        );
    };

    const checkboxChangeHandler = (orderHash) => (event) => {
        const newState = { ...state };
        newState.changes[ orderHash ] = event.target.checked;
        
        const orderIndex = newState.ordersArray.findIndex(orderInfo => orderInfo.orderHash === orderHash);
        newState.ordersArray[ orderIndex ].isWithdrawn = event.target.checked;

        setState(() => { return(newState); });
    };

    const saveButtonHandler = async () => {
        await axios.post(config.backendUrl + '/order/error-orders-save-is-withdrawn', state.changes, { headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
        } })
        .then(response => alert(response.data.message))
        .catch(error => {
            console.log(error.message);
            console.log(error.response.data.message);
            console.log(error);
            alert(error.response.data.message);
        });
    };

    return(
        <>
            <CheckAuth />
            <Menu />
            { renderTable() }
        </>
    );
};
